import { BaseApiService } from "../base/base-api.service";
import { CashTransactionDTO } from "../../models/cash-transaction/cash-transaction-dto";
import { CashTransactionSTO } from "../../models/cash-transaction/cash-transaction-sto";
import { Page } from "../../models/api/page/page";
import { SearchOptions } from "../../models/search-options/search-options";
import { toastifyResponse } from "../../utils/toastify-response/toastify-response";
import { SaveResponse } from "../../models/api/save/save.response";
import { CashTransactionsFilter } from "../../models/cash-transaction/cash-transactions.filter";
import { CashStatementsQuickFilter } from "../../containers/Quickfilters/CashStatementsQuickFilter/interfaces";
import { LegalEntityQuickFilter } from "../../containers/Quickfilters/LegalEntityQuickfilter/interfaces";

export class CashTransactionsApiService extends BaseApiService<CashTransactionDTO, CashTransactionSTO> {
  constructor() {
    super({
      servicePath: "/LegalEntityCashStatements",
      loadItemsPath: "/GetCashTransactions",
      saveItemsPath: "/SaveCashTransactions",
    });
  }
}

export const loadCashTransactions = async (
  propsFilter: {
    cashStatements: CashStatementsQuickFilter["cashStatements"];
    legalEntities: LegalEntityQuickFilter["legalEntities"];
    year: number;
    withoutJustificationDoc: boolean;
    withoutTransactionLinks: boolean;
    forecastsOnly: boolean;
  },
  page: Page,
  searchOptions: SearchOptions,
  signal: AbortSignal
) => {
  const { query, exactMatch } = searchOptions;

  const response = await new CashTransactionsApiService().loadItems(
    {
      ids: [],
      isDeleted: false,
      createdByUsers: [],
      modifiedByUsers: [],
      legalEntityIds: [...propsFilter.legalEntities.legalEntityIds],
      cashStatementIds: [...propsFilter.cashStatements.cashStatementsIds],
      year: propsFilter.year,
      withoutJustificationDoc: propsFilter.withoutJustificationDoc,
      withoutTransactionLinks: propsFilter.withoutTransactionLinks,
      forecastsOnly: propsFilter.forecastsOnly,
    } as CashTransactionsFilter,
    query,
    [],
    page,
    exactMatch,
    60,
    signal
  );

  toastifyResponse(response, "failed");

  return response;
};

export const saveCashTransaction = async (
  transaction: CashTransactionSTO,
  onlyFailedMessage?: boolean
): Promise<SaveResponse> => {
  const response = await new CashTransactionsApiService().saveItems([transaction]);

  onlyFailedMessage
    ? toastifyResponse(response, "failed")
    : toastifyResponse(response, "all", "default_success_message", "default_cancellation_message", "error_saving_data");

  return response;
};

export const loadCashTransaction = async (id: string) => {
  const response = await new CashTransactionsApiService().loadItems({
    ids: [id],
  });

  toastifyResponse(response, "failed");

  return response;
};
